export type MapFitOptions = {
  /** Room kept clear at each edge, e.g. under the floating controls along the top. */
  padding?: number | google.maps.Padding;
  /** The zoom for a single point, which has no bounds to fit. */
  singlePointZoom?: number;
};

/** Leaves room for the live map's controls along the top and its panels down the side. */
export const LIVE_MAP_FIT_PADDING: google.maps.Padding = {top: 72, right: 48, bottom: 48, left: 48};

/** Zooms the map to show every point; false when there was nothing to show. */
export const fitMapToPoints = (
  map: google.maps.Map,
  points: google.maps.LatLngLiteral[],
  {padding = LIVE_MAP_FIT_PADDING, singlePointZoom = 15}: MapFitOptions = {},
): boolean => {
  if (points.length === 0) return false;
  const [first] = points;
  if (points.every(({lat, lng}) => lat === first.lat && lng === first.lng)) {
    map.panTo(first);
    map.setZoom(singlePointZoom);
    return true;
  }
  const bounds = new google.maps.LatLngBounds();
  for (const point of points) bounds.extend(point);
  map.fitBounds(bounds, padding);
  return true;
};
